import { useCommunityBackAction as useCommunityBackActionNative } from './useCommunityBackAction.shared'

export const useCommunityBackAction = ({ redirect }: { redirect: string | undefined }) =>
  useCommunityBackActionNative({
    referrerAction: document.referrer && history.length > 1 ? () => ({ onBackPress: () => history.back() }) : undefined,
    redirect,
  })
